module.exports = __webpack_public_path__ + "static/media/bkg-wall-e-05.70003a1b.jpg";